import ObservedObject from 'observed-object'

const observedObject = new ObservedObject()

export default observedObject
